/* src/app/modules/institutions/institutions-characteristics/institutions-characteristics.component.scss */
/*# sourceMappingURL=institutions-characteristics.component.css.map */
